'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import {
  tableBodyStyles,
  tableRowStyles,
  tableSkeletonBarStyles,
} from './Table.styles'
import {
  useTableColorScheme,
  useTableDensity,
  useTableVariant,
} from './TableContext'

export type TableBodyProps = {
  children?: React.ReactNode
  /** When true, renders skeleton rows instead of children. */
  isLoading?: boolean
  /** Number of skeleton rows to render while loading. Defaults to 10. */
  skeletonRowCount?: number
}

export const TableBody = ({
  children,
  isLoading = false,
  skeletonRowCount = 10,
}: TableBodyProps) => {
  const colorScheme = useTableColorScheme()
  const density = useTableDensity()
  const variant = useTableVariant()

  if (isLoading) {
    return (
      <Box {...tableBodyStyles}>
        {Array.from({ length: skeletonRowCount }).map((_, index) => (
          <Box
            {...tableRowStyles(
              colorScheme,
              false,
              false,
              false,
              density,
              variant
            )}
            key={`skeleton-${index}`}
          >
            <Box alignItems='center' display='flex' flex='1' px='16px'>
              <Box {...tableSkeletonBarStyles(colorScheme, density)} />
            </Box>
          </Box>
        ))}
      </Box>
    )
  }

  return <Box {...tableBodyStyles}>{children}</Box>
}
